import { motion } from "framer-motion";

const industries = [
  { name: "Restaurants", img: "https://images.unsplash.com/photo-1750950388492-f803d12c4a8a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", note: "Dine-in · QSR · Catering" },
  { name: "Retail", img: "https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", note: "Brick & mortar · Boutique" },
  { name: "Construction", img: "https://images.pexels.com/photos/9405517/pexels-photo-9405517.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", note: "GC · Trades · Specialty" },
  { name: "Medical", img: "https://images.pexels.com/photos/4173251/pexels-photo-4173251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", note: "Practices · Dental · Vet" },
  { name: "Trucking", img: "https://images.pexels.com/photos/29786116/pexels-photo-29786116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", note: "Owner-op · Fleets" },
  { name: "E-commerce", img: "https://images.pexels.com/photos/4498152/pexels-photo-4498152.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900", note: "DTC · Amazon · Shopify" },
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="py-24 md:py-32 bg-[#070F1B] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-gold mb-5">Industries We Serve</div>
          <h2 className="font-heading text-4xl md:text-5xl font-light text-white tracking-tighter">
            Capital for the businesses that move the economy.
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {industries.map((ind, i) => (
            <motion.a
              key={ind.name}
              href="#apply"
              data-testid={`industry-${ind.name.toLowerCase()}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
              className="group relative aspect-[4/5] md:aspect-[4/5] overflow-hidden block"
            >
              <img
                src={ind.img}
                alt={ind.name}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-[#050B14]/40 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-7">
                <div className="text-[10px] tracking-[0.25em] uppercase text-gold font-bold mb-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  {ind.note}
                </div>
                <div className="font-heading text-xl md:text-2xl text-white">{ind.name}</div>
              </div>
              <div className="absolute inset-0 ring-1 ring-inset ring-white/0 group-hover:ring-gold/50 transition-all" />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
